// extracted by mini-css-extract-plugin
export var budget = "RangeSliderMobile-module--budget--82cf0";
export var container = "RangeSliderMobile-module--container--eceb7";
export var description = "RangeSliderMobile-module--description--b2dd7";
export var duration = "RangeSliderMobile-module--duration--8658f";
export var fadeInAnimation = "RangeSliderMobile-module--fadeInAnimation--4a248";
export var months = "RangeSliderMobile-module--months--55393";
export var rangeTitle = "RangeSliderMobile-module--rangeTitle--8c286";
export var slider = "RangeSliderMobile-module--slider--ecd23";
export var step = "RangeSliderMobile-module--step--df023";
export var tickets = "RangeSliderMobile-module--tickets--6f083";
export var title = "RangeSliderMobile-module--title--7fe56";